module.exports = __webpack_public_path__ + "user_referrals.72602dfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/user_referrals.png
// module id = 473
// module chunks = 0